import React from 'react'

const index = () => {
  return (
    <div>Accounting</div>
  )
}

export default index